module.exports = __webpack_public_path__ + "static/img/systemName.31f03552.png";